const config = {
    local: {
        serverUrl: "http://localhost:8006",
        operationsUrl: "http://localhost:8005",
        autosUrl: "http://localhost:8003",
    },
    development: {
        // serverUrl: "https://dev-panel-backend.mobilityinfotech.com:8452",
        serverUrl: "http://localhost:8006",
        //  serverUrl: "https://dev.mobilityinfotech.com:8885",

        // operationsUrl: "https://dev-patch-opr.mobilityinfotech.com",
        operationsUrl: "http://localhost:8005",
        // operationsUrl: "https://dev.mobilityinfotech.com:8886",

        // autosUrl: "http://dev.togopool.com:8008"
        autosUrl: "https://dev-taxi-central.mobilityinfotech.com",
        // autosUrl: "https://dev.mobilityinfotech.com:8449",

        chatUrl: "https://dev.mobilityinfotech.com:8456"
    },
    production: {
        serverUrl: "https://dev.mobilityinfotech.com:8452",
        operationsUrl: "https://dev.mobilityinfotech.com:8451",
        autosUrl: "https://dev-taxi-central.mobilityinfotech.com",
        chatUrl: "https://dev.mobilityinfotech.com:8456"
    },
    europe_prod : {
        serverUrl: "https://prod-eu.mobilityinfotech.com:7446",
        operationsUrl: "https://prod-eu.mobilityinfotech.com:7445",
        autosUrl: "https://prod-eu.mobilityinfotech.com:7443"
    }
};
  
// Export the config based on the current environment
const environment =  'production';
export default config[environment];